import { SimpleDropdown } from "@circle-react/components/shared/uikit/SimpleDropdown";
import type { Appearance } from "@circle-react-shared/BuilderUI/Store/interfaceSlice";
import type { SiteTheme } from "../../constants";
import type { useGetThemes } from "../../useGetThemes";
import { ThemeOptionLabel } from "../ThemeOptionLabel";

interface ThemeSelectorProps {
  appearance: Appearance;
  currentCanvasTheme: SiteTheme;
  newThemeId: number | null;
  onThemeChange: (themeId: number) => void;
  themes: NonNullable<ReturnType<typeof useGetThemes>["data"]>;
}

export const ThemeSelector = ({
  appearance,
  currentCanvasTheme,
  newThemeId,
  onThemeChange,
  themes,
}: ThemeSelectorProps) => {
  const handleThemeChange = (themeValue: string | number) => {
    const selectedTheme = themes.find(theme => theme.value === themeValue);
    if (selectedTheme) {
      onThemeChange(selectedTheme.value);
    }
  };

  const options = themes
    .filter(theme => theme.value !== currentCanvasTheme.value)
    .map(theme => ({
      id: theme.value,
      value: theme.value,
      label: (
        <ThemeOptionLabel
          key={theme.value}
          theme={theme}
          appearance={appearance}
        />
      ),
    }));

  return (
    <SimpleDropdown
      className="!flex"
      value={newThemeId}
      onChange={handleThemeChange}
      menuItems={options}
      fullWidth
    />
  );
};
